import React, { useCallback, useRef, useState } from 'react';
import PropTypes from "prop-types";

import config from 'config';

import { EntityImage } from './entity_image';
import i18next from "i18next";

const EntityImageGallery = ({ serialNumber, images, onDelete, onReplace, hideZoom }) => {
  const [loading, setLoading] = useState(images.length > 0);
  const galleryRef = useRef(null);

  const handleImageChange = useCallback((err) => {
    if (err) {
      console.error(err);
    }

    const incompleteImages = [...galleryRef.current.querySelectorAll("img.device-image-in-situ")].filter((img) => !img.complete);
    
    setLoading(incompleteImages.length > 0);
  }, [serialNumber]);
  
  return (
    <div className="gallery" ref={galleryRef} style={{maxHeight: 100, height: 100}}>
      <div className={loading ? 'hidden' : 'image-header'}>
        { 
          images.length > 0 ? images.map((image, index) =>
            <EntityImage 
              key={index} 
              index={index} 
              isPrimary={image.primary} 
              image={`${config.API_BASE_URL}entities/${serialNumber}/images/${image.name ? image.name : image}`}
              onImageChange={handleImageChange} 
              onDeleteImage={onDelete} 
              onReplaceImage={onReplace}
              hideZoom={hideZoom} />
          ) 
          :
          <div className="no-image-found-box"><img src={`${config.WEB_BASE_URL}/images/icon/no_image_icon.svg`}/><em>{ i18next.t('no-image-found') }</em></div>
        }
      </div>
      { loading && <div className="loader">{ i18next.t('loading') }</div> }
    </div>
  );
}

EntityImageGallery.propTypes = {
    serialNumber: PropTypes.string.isRequired,
    images: PropTypes.array.isRequired,
    onDelete: PropTypes.func,
    onReplace: PropTypes.func
};

export default EntityImageGallery;